import { render, staticRenderFns } from "./SidebarCardRelatedAssets.vue?vue&type=template&id=58252b50"
import script from "./SidebarCardRelatedAssets.vue?vue&type=script&lang=js"
export * from "./SidebarCardRelatedAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports